import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/financial-management/debt`;

export const debtRoutesObj = {
  list: baseRoute,
} as const;

export type IDebtRouteParams = IExtractRouteParamMap<typeof debtRoutesObj>;

export const debtPath = createPaths<typeof debtRoutesObj, IDebtRouteParams>(
  debtRoutesObj,
);
